import {NgModule} from '@angular/core';
import {HeaderComponent} from './header/header';
import {ShopQueueComponent} from './shop-queue/shop-queue';
import {ShopAboutComponent} from './shop-about/shop-about';
import {ShopLocationsComponent} from './shop-locations/shop-locations';
import {ShopCutsComponent} from './shop-cuts/shop-cuts';
import {GoogleMapsComponent} from './google-maps/google-maps';
import {IonicModule} from 'ionic-angular';
import {TrendingCutsFavouritesComponent} from './trending-cuts-favourites/trending-cuts-favourites';
import {TrendingCutsListComponent} from './trending-cuts-list/trending-cuts-list';
import {TrendingCutsGridComponent} from './trending-cuts-grid/trending-cuts-grid';
import {SocialIconsComponent} from './social-icons/social-icons';
import {AdvertComponent} from './advert/advert';
import {LoadingComponent} from './loading/loading';
import {CountdownTimerComponent} from './countdown-timer/countdown-timer';
import {StaffCurrentQueueComponent} from './staff-current-queue/staff-current-queue';
import {StaffAdvancedBookingsComponent} from './staff-advanced-bookings/staff-advanced-bookings';
import {StaffCompletedBookingsComponent} from './staff-completed-bookings/staff-completed-bookings';
import {MoreOptionsComponent} from './more-options/more-options';
import {LoginRequiredComponent} from './login-required/login-required';
import {LoadingButtonComponent} from "./loading-button/loading-button";
import {FlipClockComponent} from "./flip-clock/flip-clock";
import {BookingCardComponent} from "./booking-card/booking-card";
import {StaffMemberComponent} from './staff-member/staff-member';
import {PaidComponent} from "./paid/paid";
import {BannerComponent} from './banner/banner';
import {FooterAppDownloadComponent} from "./footer-app-download/footer-app-download";
import {PoweredByComponent} from "./powered-by/powered-by";
import {ShopCardsComponent} from './shop-cards/shop-cards';
import {PipesModule} from "../pipes/pipes.module";
import {LoyaltyComponent} from "./loyalty/loyalty";
import {BookingTotalsComponent} from "./booking-totals/booking-totals";
import { CancelledBookingBannerComponent } from './cancelled-booking-banner/cancelled-booking-banner';
import { InviteBarbershopComponent } from './invite-barbershop/invite-barbershop';
import { ShopStaffHoursComponent } from './shop-staff-hours/shop-staff-hours';
import { CoffeShopCardComponent } from './coffe-shop-card/coffe-shop-card';
import { CoffeShopHeaderComponent } from './coffe-shop-header/coffe-shop-header';
import { ShopGridComponent } from './shop-grid/shop-grid';
import { CustomBookinCardComponent } from './custom-bookin-card/custom-bookin-card';

@NgModule({
  declarations: [
    HeaderComponent,
    ShopQueueComponent,
    ShopAboutComponent,
    ShopLocationsComponent,
    ShopCutsComponent,
    GoogleMapsComponent,
    TrendingCutsFavouritesComponent,
    TrendingCutsListComponent,
    TrendingCutsGridComponent,
    SocialIconsComponent,
    AdvertComponent,
    LoadingComponent,
    LoadingButtonComponent,
    CountdownTimerComponent,
    StaffCurrentQueueComponent,
    StaffAdvancedBookingsComponent,
    StaffCompletedBookingsComponent,
    MoreOptionsComponent,
    CountdownTimerComponent,
    LoginRequiredComponent,
    FlipClockComponent,
    BookingCardComponent,
    StaffMemberComponent,
    PaidComponent,
    BannerComponent,
    FooterAppDownloadComponent,
    PoweredByComponent,
    ShopCardsComponent,
    LoyaltyComponent,
    BookingTotalsComponent,
    CancelledBookingBannerComponent,
    InviteBarbershopComponent,
    ShopStaffHoursComponent,
    CoffeShopCardComponent,
    CoffeShopHeaderComponent,
    ShopGridComponent,
    CustomBookinCardComponent
  ],
  imports: [
    IonicModule,
    PipesModule
  ],
  exports: [
    HeaderComponent,
    ShopQueueComponent,
    ShopAboutComponent,
    ShopLocationsComponent,
    ShopCutsComponent,
    GoogleMapsComponent,
    TrendingCutsFavouritesComponent,
    TrendingCutsListComponent,
    TrendingCutsGridComponent,
    SocialIconsComponent,
    AdvertComponent,
    LoadingComponent,
    LoadingButtonComponent,
    CountdownTimerComponent,
    StaffCurrentQueueComponent,
    StaffAdvancedBookingsComponent,
    StaffCompletedBookingsComponent,
    MoreOptionsComponent,
    CountdownTimerComponent,
    LoginRequiredComponent,
    FlipClockComponent,
    BookingCardComponent,
    StaffMemberComponent,
    PaidComponent,
    BannerComponent,
    FooterAppDownloadComponent,
    PoweredByComponent,
    ShopCardsComponent,
    LoyaltyComponent,
    BookingTotalsComponent,
    CancelledBookingBannerComponent,
    InviteBarbershopComponent,
    ShopStaffHoursComponent,
    CoffeShopCardComponent,
    CoffeShopHeaderComponent,
    ShopGridComponent
  ],
  entryComponents: [
    CustomBookinCardComponent
  ],
})
export class ComponentsModule {
}



// WEBPACK FOOTER //
// ./src/components/components.module.ts